<div class="kd-document-snippet">
    <pre
        class="content"
        [ngClass]="syntax"
    ></pre>
</div>
